import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollAnimation from 'react-animate-on-scroll';
import PricingItem from "../components/pricingItem/index";

export class Pricing extends Component {
    render() {
        const { changeTab } = this.props;
        return (
            <React.Fragment>
                <section id="pricing" className="our-pricing ptb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2 text-center">
                                <ScrollAnimation animateIn="fadeInUp">
                                    <div className="section-title">
                                        <h2>{this.props.sectionTitle}</h2>
                                        {/*<p>{this.props.sectionDescription}</p>*/}
                                        <span className="section-title-bg">{this.props.SectionbgTitle}</span>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                    {<PricingItem changeTab={changeTab} />
                        /*
                            <div className="row">
                            <div className="col-lg-12">
                                <div className="tab-slider">
                                    <Tabs defaultActiveKey="monthly" id="uncontrolled-tab">
                                        <Tab eventKey="monthly" title="Monthly">
                                            <ItemOne />
                                        </Tab>
                                        <Tab eventKey="yearly" title="Yearly">
                                            <ItemTwo />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                        */

                    }
                        
                    </div>
                </section>
            </React.Fragment>
        );
    }
}
//Props Types
Pricing.propTypes = {
    SectionbgTitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    sectionDescription: PropTypes.string,
};

//Default Props
Pricing.defaultProps = {
    SectionbgTitle: "Donate",
    sectionTitle: "贊助計劃",
    sectionDescription:
        "",

};
export default Pricing
